import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../../infra/hooks";
import { pendingRequestsService } from "../../../../api/services/pendingRequestsService";
import { pendingRequestReducer } from "../../../../infra/aggregates/pendingRequestSlice";
import { timelineReducerLoader } from "../../../../infra/aggregates/timelineSlice";

interface PropsValues {
  setPendingRequestsData: (data: []) => void;
}

function DTOPendingRequests({ setPendingRequestsData }: PropsValues) {
  const selector = useAppSelector((state) => state);
  const dispatch = useAppDispatch();

  async function getPendingRequests(empId: number) {
    dispatch(timelineReducerLoader(true));
    const response = await pendingRequestsService.pendingRequests(empId);
    if (response) {
      dispatch(pendingRequestReducer(response.data));
      setPendingRequestsData(response.data);
      dispatch(timelineReducerLoader(false));
    } else {
      dispatch(timelineReducerLoader(false));

      return;
    }
  }
  useEffect(() => {
    if (selector.authSlice.emp_id) {
      getPendingRequests(selector.authSlice.emp_id);
    }
  }, []);
  return <></>;
}
export default DTOPendingRequests;
